/* eslint-disable no-console */
export enum Environment {
    PROD = 'prod',
    DEV = 'dev'
}


// Note: This should come from the system.
const environment = Environment.PROD


interface Window {
    __DEBUG_MODE__: boolean;
}


declare let window: Window

/**
 * Exposed to window. Flag for allowing debug to go to console.
 * @namespace __DEBUG_MODE__
 * @type {boolean}
 * @private
 */
window.__DEBUG_MODE__ = environment !== Environment.PROD

/**
 * Is debugging enabled
 * @return {*|boolean}
 */
function debugEnabled() {
    return true
    // return window.__DEBUG_MODE__
}


enum ConsoleType {
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error'
}


/**
 * @param {string} outputType: Key for console
 * @param {string} message: Messages to be printed to console
 * @private
 */
function _output(outputType: ConsoleType, ...message: string[]): void {
    if (debugEnabled()) {
        console[outputType](...message)
    }
}

export default {
    info: _output.bind(null, ConsoleType.INFO),
    warn: _output.bind(null, ConsoleType.WARN),
    error: _output.bind(null, ConsoleType.ERROR)
}
